import { render, staticRenderFns } from "./contato.vue?vue&type=template&id=232662ab&scoped=true"
import script from "./contato.vue?vue&type=script&lang=js"
export * from "./contato.vue?vue&type=script&lang=js"
import style0 from "./contato.vue?vue&type=style&index=0&id=232662ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232662ab",
  null
  
)

export default component.exports